import { AcquiringOwnerId, RefillType } from 'app/dataTypes/acquiring/settings'

import { useAcquiringSettingsData } from './useAcquiringSettingsData'

export function useAcquiringSettingsRefillStyle(
  type: RefillType | null,
  id: AcquiringOwnerId | null,
) {
  const refillSettings = useAcquiringSettingsData()

  return (type && id && refillSettings[type].get(id)?.refillStyle) || null
}
